import router, { asyncRoutes, constantRoutes } from "@/router";
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}
export function filterAsyncRoutes(routes, roles) {
  const res = [];
  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}

const state = {
  routes: [],
  addRoutes: [],
  order_total: 0
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    let routesResult = [...constantRoutes, ...routes];
    // 公告中心放最后
    let notice = routesResult.findIndex(item => {
      return item.path.includes("notice");
    });
    if (notice !== -1) {
      let noticeRoute = routesResult[notice];
      routesResult.splice(notice, 1);
      routesResult.push(noticeRoute);
    }
    let common = routesResult.findIndex(item => {
      return item.path.includes("*");
    });
    if (common !== -1) {
      routesResult.splice(common, 1);
    }
    routesResult.push({ path: "*", redirect: "/", hidden: true });
    routesResult.forEach(item => {
      if (!item.meta) {
        item.meta = {};
      }
      item.meta.isParent = true;
    });
    state.routes = routesResult;
  },
  CLEAR_ROUTE: state => {
    state.routes = [];
    state.addRoutes = [];
  },
  SET_DASH_DATA: (state, total) => {
    state.order_total = total;
  }
};

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes;
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      commit("SET_ROUTES", accessedRoutes);
      router.addRoutes(accessedRoutes);
      resolve(accessedRoutes);
    });
  },
  jzbGenerateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes = [];
      accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      commit("SET_ROUTES", accessedRoutes);
      if (accessedRoutes.length > 0) {
        router.addRoutes(accessedRoutes);
      }
      resolve(accessedRoutes);
    });
  },
  clearRoute({ commit }) {
    commit("CLEAR_ROUTE");
  },
  setDashboardData({ commit }, total) {
    commit("SET_DASH_DATA", total);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js